import React from 'react'
import Collection from '../common/collection'

function CollectionH({ props }) {
  return (
    <Collection
      alt="Cúpulas"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas32.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas33.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas36.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas37.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas59.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/7.+c%C3%BApulas64.jpg',
      ]}
    />
  )
}


export default CollectionH
